import { AuthState } from '@okta/okta-auth-js';

import { EndOfDay } from '../../services/backend/EndOfDay';
import { useBaseApiClient } from '../useBaseApiClient';

export const useEndOfDay: () => EndOfDay<AuthState> = () => {
  return useBaseApiClient(EndOfDay);
};
